import { Routes } from '@angular/router';

export const routes: Routes = [
  // ❌ Página de erro (antes do path ''): /error não pode cair no ** de site.routes (NG04016).
  {
    path: 'error',
    loadComponent: () =>
      import('./error/error.component').then((m) => m.ErrorComponent),
    data: { animation: 'Error' },
  },

  // 🌐 Módulo de rotas do site
  {
    path: '',
    loadChildren: () =>
      import('./routes/site.routes').then((m) => m.siteRoutes),
  },

  // 🌐 Módulo de rotas do login
  {
    path: 'login',
    loadChildren: () =>
      import('./routes/login.routes').then((m) => m.loginRoutes),
  },

  // 🌐 Módulo de rotas de esqueci minha senha
  {
    path: 'esqueci-minha-senha',
    loadChildren: () =>
      import('./routes/esqueci-minha-senha.routes').then(
        (m) => m.esqueciMinhaSenhaRoutes
      ),
  },

  // 🌐 Módulo de rotas de criar conta
  {
    path: 'criar-conta',
    loadChildren: () =>
      import('./routes/create-account.routes').then(
        (m) => m.createAccountRoutes
      ),
  },

  // 🌐 Módulo de rotas de parceiros
  {
    path: 'seja-um-parceiro',
    loadChildren: () =>
      import('./routes/be-a-partner.routes').then((m) => m.partnerRoutes),
  },

  // 🌐 MCP OAuth — consentimento de acesso para IAs externas
  {
    path: 'mcp',
    loadChildren: () =>
      import('./routes/mcp.routes').then((m) => m.mcpRoutes),
  },

  // 🌐 Módulo de rotas da minha-conta (Protegido por AuthGuard)
  {
    path: 'minha-conta',
    loadChildren: () =>
      import('./routes/minha-conta.routes').then((m) => m.minhaContaRoutes),
  },

  // 🌐 Módulo de rotas da apolice
  {
    path: 'certificado-da-apolice',
    loadChildren: () =>
      import('./routes/apolice.routes').then((m) => m.apoliceRoutes),
  },

  // Documento da parceria. Fora do AuthGuard; a API exige admin ou o parceiro dono. Fora do catálogo de IA do segurado.
  {
    path: 'termos-de-parceria/:partnerId',
    loadComponent: () =>
      import('./termos-de-parceria/termos-de-parceria.component').then(
        (m) => m.TermosDeParceriaComponent
      ),
  },

  // 🧭 Catch-all (qualquer rota desconhecida vai para /error)
  { path: '**', redirectTo: 'error' },
];
